import React from "react";
import Form from "Components/Core/Form/Form";
import FormElement from "Components/Core/Form/FormElement";
import PostingList from "./PostingList";
import 'CSS/Forum/PostingSearch.css';

export default function PostingSearch(props) {

    const x = props.x;
	const [postingCount, setPostingCount] = React.useState(-2);       	// Enthält die Anzahl der gefundenen Beiträge
	const [members, setMembers] = React.useState([]);
	const [memberId, setMemberId] = React.useState('');
	const waf =  x.waf;
	const wafId = props.dialogId;
	const formId = props.dialogId + '-form';
	const isComplexSearch = React.useRef(false);				// true, wenn die aktuelle Suche Joker (*/?) enthält und dadurch länger dauern kann

	const postingList = [];										// Hier werden Zeiger auf die benötigten Funktionen der PostingList-Komponenten gespeichert

	x.wam.init(props.moduleId, {
		"onClose":() => {
			delete x.waf[wafId];
		}
	})


	React.useEffect(() => {
		x.waf.set(wafId, 'search', '');
		x.waf.focus(wafId, 'search');
		x.was.axGet('Backend/webapp.php?module=Member&task=MemberList', (result) => {
			if (result.data['returncode'] === 1) {
				const sortedMembers = [...result.data['content']].sort((a, b) => a.membername.localeCompare(b.membername));
				setMembers(sortedMembers);
			}
		});
	} , [waf, wafId, x]);

	function onAfterReadPostings(result) {
		setPostingCount(result.data['content'].length);
	}

	function searchPosting(event) {
		event.preventDefault();
		const search = x.waf.get(wafId, 'search');
		isComplexSearch.current = /[*?]/.test(search);
		setPostingCount(-1); // -1 = Suche wird ausgeführt
		postingList.reset();
		let addUrl = '&search=' + search;
		addUrl += '&forumid=' + props.forumId;
		addUrl += '&memberid=' + memberId;
		postingList.addSearchUrl(addUrl) ;
		postingList.searchPostings();
	}

	function newSearch() {
		setPostingCount(-2);
		x.waf[wafId].setPostingSource([]);
		x.waf.set(wafId, 'search', '');
		x.waf.focus(wafId, 'search');
	}

	function makeStatus(postingCount) {
		let searchStatus = null;
		let maxMessage = '';
		switch (postingCount) {
			case -2:
				searchStatus = <span></span>
				break;
			case -1:
				searchStatus = <span>Suche wird ausgeführt{isComplexSearch.current ? ' (kann bei Verwendung von Jokern etwas länger dauern)' : ''}...</span>
				break;
			default:
				maxMessage = (postingCount === 1000) ? '(Maximum von 1000 erreicht)' : ''
				searchStatus =
					<span>
						<i id="new-search" className="bi bi-x-circle module-icon module-icon-clicked" onClick={e => newSearch()}>
							<span id="posting-count">{postingCount} {'Treffer' + maxMessage}</span>
						</i>
					</span>

		}

		return (
			<div key="search-status" id="search-status" className="search-status" >
				{searchStatus}
			</div>
		)
	}

	return (
		<div className="div-search-posting">
			<Form id={formId}
				className="form-search-posting"
				x={x}  
				wafId={wafId}
				sendButton={false}
				cancelButton={false}
				onSubmit={e => searchPosting(e)}
				dialogId={props.dialogId}
				sendButtonTitle="Suchen"
				autocomplete="off">
				<FormElement type="search" x={x}   wafId={wafId} id={'search'} dialogId={props.dialogId} title="Suche nach Titel:" maxLength="150" />
			</Form>
			<select className="search-member-select" value={memberId} onChange={(e) => setMemberId(e.target.value)}>
				<option value="">Alle Mitglieder</option>
				{members.map((member) => (
					<option key={member.memberid} value={member.memberid}>{member.membername}</option>
				))}
			</select>
			<div className="search-hint">Mehrere Suchwörter werden UND-verknüpft (ein Treffer muss alle Wörter enthalten). Joker (*, ?) benötigen mindestens 3 Buchstaben davor oder danach, z.B. "gute*" oder "*wort"</div>
			<div className="div-status">
				{makeStatus(postingCount)}
			</div>
			<PostingList
					id="search-postings"
					x={x}  
					forumId={props.forumId}
					moduleId={props.moduleId}
					dialogId={props.dialogId}
					functionName="searchPostings"
					onRendered={(functions) => {
									postingList.addSearchUrl = functions.addSearchUrl;
									postingList.searchPostings = functions.searchPostings;
									postingList.reset = functions.reset;
								}}
					module="Posting"
					task="PostingSearch"
					showDialogAnswer={props.showDialogAnswer}
					onAfterReadPostings={onAfterReadPostings}
					copyToClipboard={props.copyToClipboard}
			/>
		</div>
	);


}
